declare namespace $ {

	type $shm_hitalama_map_command_palette__opened_shm_hitalama_app_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['command_palette_opened'] >
		,
		ReturnType< $shm_hitalama_map_command_palette['opened'] >
	>
	type $mol_check_icon__hint_shm_hitalama_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_app_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['History_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_app_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['history_opened'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__hint_shm_hitalama_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_app_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Process_monitor_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_app_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['process_monitor_opened'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $shm_hitalama_mbutton__checked_shm_hitalama_app_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_opened'] >
		,
		ReturnType< $shm_hitalama_mbutton['checked'] >
	>
	type $mol_view__sub_shm_hitalama_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_app_fullscreen__map_book_shm_hitalama_app_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Map'] >
		,
		ReturnType< $shm_hitalama_app_fullscreen['map_book'] >
	>
	type $shm_hitalama_app_fullscreen__overlay_panel_shm_hitalama_app_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Overlay_panel'] >
		,
		ReturnType< $shm_hitalama_app_fullscreen['overlay_panel'] >
	>
	type $shm_hotkey__scope_shm_hitalama_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hotkey['scope'] >
	>
	type $shm_hotkey__root_shm_hitalama_app_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['dom_node'] >
		,
		ReturnType< $shm_hotkey['root'] >
	>
	type $shm_hitalama_footer__version_shm_hitalama_app_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_version'] >
		,
		ReturnType< $shm_hitalama_footer['version'] >
	>
	type $shm_hitalama_footer__date_shm_hitalama_app_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_date'] >
		,
		ReturnType< $shm_hitalama_footer['date'] >
	>
	type $shm_hitalama_footer__available_version_shm_hitalama_app_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_available'] >
		,
		ReturnType< $shm_hitalama_footer['available_version'] >
	>
	type __shm_hitalama_app_17 = $mol_type_enforce<
		Parameters< $shm_hitalama_app['Spread'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_app['Book'] >['Spread'] >[0]
	>
	type $mol_text__text_shm_hitalama_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__head_shm_hitalama_app_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_hitalama_app_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_components_embed__title_shm_hitalama_app_22 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_embed['title'] >
	>
	type $shm_hitalama_components_embed__fqn_shm_hitalama_app_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['analysis_fqn'] >
		,
		ReturnType< $shm_hitalama_components_embed['fqn'] >
	>
	type $shm_hitalama_vk_lists__token_shm_hitalama_app_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['token'] >
		,
		ReturnType< $shm_hitalama_vk_lists['token'] >
	>
	type $shm_hitalama_map_catalog__maps_list_visible_shm_hitalama_app_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['maps_list_visible'] >
		,
		ReturnType< $shm_hitalama_map_catalog['maps_list_visible'] >
	>
	type $shm_hitalama_projects__menu_title_shm_hitalama_app_26 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_projects['menu_title'] >
	>
	type $shm_hitalama_projects__projects_list_visible_shm_hitalama_app_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['projects_list_visible'] >
		,
		ReturnType< $shm_hitalama_projects['projects_list_visible'] >
	>
	type $shm_hitalama_projects__maps_shm_hitalama_app_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Maps'] >
		,
		ReturnType< $shm_hitalama_projects['maps'] >
	>
	type $shm_hitalama_benchmarks_page__version_shm_hitalama_app_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_version'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page['version'] >
	>
	type $shm_hitalama_profile_page__profiles_shm_hitalama_app_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['profiles'] >
		,
		ReturnType< $shm_hitalama_profile_page['profiles'] >
	>
	type $shm_listener__shm_hitalama_app_31 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_app['command_palette_keydown_handler'] >, ReturnType< $shm_hitalama_app['document'] >, ({ 
			'passive': boolean,
		})  ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_hitalama_version_label__version_shm_hitalama_app_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_version'] >
		,
		ReturnType< $shm_hitalama_version_label['version'] >
	>
	type $shm_hitalama_version_label__date_shm_hitalama_app_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_date'] >
		,
		ReturnType< $shm_hitalama_version_label['date'] >
	>
	type $shm_hitalama_version_label__available_version_shm_hitalama_app_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_available'] >
		,
		ReturnType< $shm_hitalama_version_label['available_version'] >
	>
	type $shm_hitalama_app_book__maps_list_visible_shm_hitalama_app_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['maps_list_visible'] >
		,
		ReturnType< $shm_hitalama_app_book['maps_list_visible'] >
	>
	type $shm_hitalama_app_book__projects_list_visible_shm_hitalama_app_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['projects_list_visible'] >
		,
		ReturnType< $shm_hitalama_app_book['projects_list_visible'] >
	>
	type $shm_hitalama_app_book__param_shm_hitalama_app_37 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_app_book['param'] >
	>
	type $shm_hitalama_app_book__menu_title_shm_hitalama_app_38 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_app_book['menu_title'] >
	>
	type $shm_hitalama_app_book__menu_tools_shm_hitalama_app_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_app_book['menu_tools'] >
	>
	type $shm_hitalama_app_book__menu_foot_shm_hitalama_app_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_app_book['menu_foot'] >
	>
	type $shm_hitalama_app_book__placeholders_shm_hitalama_app_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_app_book['placeholders'] >
	>
	type $shm_hitalama_app_book__pages_shm_hitalama_app_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['book_pages'] >
		,
		ReturnType< $shm_hitalama_app_book['pages'] >
	>
	type $shm_hitalama_app_book__spreads_shm_hitalama_app_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['menu_spreads'] >
		,
		ReturnType< $shm_hitalama_app_book['spreads'] >
	>
	type $shm_hitalama_guide_panel__section_shm_hitalama_app_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['guide_section'] >
		,
		ReturnType< $shm_hitalama_guide_panel['section'] >
	>
	type $shm_hitalama_guide_panel__param_shm_hitalama_app_45 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_panel['param'] >
	>
	type $shm_hitalama_resilience_page__title_shm_hitalama_app_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['recovery_title'] >
		,
		ReturnType< $shm_hitalama_resilience_page['title'] >
	>
	type $shm_hitalama_resilience_page__message_shm_hitalama_app_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['recovery_message'] >
		,
		ReturnType< $shm_hitalama_resilience_page['message'] >
	>
	type $shm_hitalama_resilience_page__details_shm_hitalama_app_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['recovery_details'] >
		,
		ReturnType< $shm_hitalama_resilience_page['details'] >
	>
	type $shm_hitalama_resilience_page__retry_visible_shm_hitalama_app_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['recovery_retry_visible'] >
		,
		ReturnType< $shm_hitalama_resilience_page['retry_visible'] >
	>
	type $shm_hitalama_profile_enter__profiles_shm_hitalama_app_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['profiles'] >
		,
		ReturnType< $shm_hitalama_profile_enter['profiles'] >
	>
	type $shm_hitalama_profile_register__profiles_shm_hitalama_app_51 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['profiles'] >
		,
		ReturnType< $shm_hitalama_profile_register['profiles'] >
	>
	type $shm_hitalama_agent_map_chat__width_shm_hitalama_app_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_agent_map_chat['width'] >
	>
	type $shm_hitalama_agent_map_chat__map_id_shm_hitalama_app_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['agent_map_id'] >
		,
		ReturnType< $shm_hitalama_agent_map_chat['map_id'] >
	>
	type $shm_hitalama_codex_map__width_shm_hitalama_app_54 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_codex_map['width'] >
	>
	type $shm_hitalama_codex_map__map_id_shm_hitalama_app_55 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['agent_map_id'] >
		,
		ReturnType< $shm_hitalama_codex_map['map_id'] >
	>
	type $shm_hitalama_agent_general__width_shm_hitalama_app_56 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_agent_general['width'] >
	>
	type $shm_hitalama_codex_general__width_shm_hitalama_app_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_codex_general['width'] >
	>
	type $shm_hitalama_project_codex__width_shm_hitalama_app_58 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_project_codex['width'] >
	>
	type $shm_hitalama_process_monitor_maps__close_shm_hitalama_app_59 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['process_monitor_close'] >
		,
		ReturnType< $shm_hitalama_process_monitor_maps['close'] >
	>
	type $shm_hitalama_map_history_view__map_shm_hitalama_app_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['map'] >
		,
		ReturnType< $shm_hitalama_map_history_view['map'] >
	>
	type $shm_hitalama_map_history_view__close_shm_hitalama_app_61 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['history_close'] >
		,
		ReturnType< $shm_hitalama_map_history_view['close'] >
	>
	export class $shm_hitalama_app extends $mol_view {
		Theme( ): $mol_theme_auto
		pass_income_auto( ): any
		telemetry_auto( ): any
		baza_sync_auto( ): any
		entergate_pending_auto( ): any
		client_pass_publish_auto( ): any
		mcp_client_auto( ): any
		projects_session_identity_auto( ): any
		projects_team_config_auto( ): any
		profile_name_publish_auto( ): any
		workspace_auto( ): readonly(any)[]
		selfhosted_tauri_admin_auto( ): any
		command_palette_keydown_handler( ): any
		document( ): any
		master_link( ): ReturnType< ReturnType< $shm_hitalama_app['Baza_status'] >['master_link'] >
		map_version_notice( ): readonly(any)[]
		command_palette_opened( next?: boolean ): boolean
		Command_palette( ): $shm_hitalama_map_command_palette
		History_toggle_icon( ): $mol_icon_history
		history_opened( next?: boolean ): boolean
		History_toggle( ): $mol_check_icon
		Process_monitor_toggle_icon( ): $mol_icon_clock_fast
		process_monitor_opened( next?: boolean ): boolean
		Process_monitor_toggle( ): $mol_check_icon
		Speech( ): $shm_hitalama_speech
		chat_opened( next?: boolean ): boolean
		Mbutton( ): $shm_hitalama_mbutton
		Right_bottom_panel( ): $mol_view
		Fullscreen( ): $shm_hitalama_app_fullscreen
		Overlay_panel( ): $shm_hitalama_app_overlay
		Hotkeys( ): $shm_hotkey
		Status( ): $giper_baza_status
		Lights( ): $mol_lights_toggle
		version_data_version( ): string
		version_data_date( ): string
		version_data_available( ): string
		Footer( ): $shm_hitalama_footer
		Book_menu( ): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['Menu'] >
		spread( ): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['spread'] >
		Spread( id: any): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['Spread'] >
		Spread_default( ): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['Spread_default'] >
		Tokens_label( ): $mol_text
		token( ): ReturnType< ReturnType< $shm_hitalama_app['Token_switch'] >['current'] >
		Token_switch( ): $shm_hitalama_vk_token_switch
		Tokens( ): $mol_view
		Profile( ): $shm_hitalama_profile_switch
		Spread_current( ): $mol_view
		Main( ): $mol_page
		side_views( ): readonly(any)[]
		book_pages( ): readonly(any)[]
		analysis_fqn( ): string
		Analysis( ): $shm_hitalama_components_embed
		Lists( ): $shm_hitalama_vk_lists
		Maps( ): $shm_hitalama_map_catalog
		Projects( ): $shm_hitalama_projects
		Applications( ): $shm_hitalama_components
		Skills( ): $shm_hitalama_skills
		Knowledge( ): $shm_knowledge
		Teams( ): $shm_hitalama_teams
		Duckdb( ): $shm_hitalama_duckdb_page
		Benchmark( ): $shm_hitalama_benchmarks_page
		Settings( ): $shm_hitalama_settings
		Profile_page( ): $shm_hitalama_profile_page
		guide_section( ): string
		recovery_title( id: any): string
		recovery_message( id: any): string
		recovery_details( id: any): string
		recovery_retry_visible( id: any): boolean
		profiles( ): $shm_hitalama_profile_dict
		Domain_page( ): $shm_hitalama_domain_page
		agent_map_id( ): string
		process_monitor_close( next?: any ): any
		history_close( next?: any ): any
		title( ): string
		map( ): $shm_hitalama_map
		maps_list_visible( next?: boolean ): boolean
		projects_list_visible( next?: boolean ): boolean
		chat_width( next?: number ): number
		plugins( ): readonly(any)[]
		auto( ): readonly(any)[]
		command_palette_keydown_listener( ): $shm_listener
		Baza_status( ): $giper_baza_status
		sub( ): readonly(any)[]
		Map_version( ): $shm_hitalama_version_label
		Book( ): $shm_hitalama_app_book
		menu_spreads( ): ({ 
			'': ReturnType< $shm_hitalama_app['Analysis'] >,
			'lists': ReturnType< $shm_hitalama_app['Lists'] >,
			'maps': ReturnType< $shm_hitalama_app['Maps'] >,
			'projects': ReturnType< $shm_hitalama_app['Projects'] >,
			'applications': ReturnType< $shm_hitalama_app['Applications'] >,
			'skills': ReturnType< $shm_hitalama_app['Skills'] >,
			'knowledge': ReturnType< $shm_hitalama_app['Knowledge'] >,
			'team': ReturnType< $shm_hitalama_app['Teams'] >,
			'duckdb_page': ReturnType< $shm_hitalama_app['Duckdb'] >,
			'benchmark': ReturnType< $shm_hitalama_app['Benchmark'] >,
			'settings': ReturnType< $shm_hitalama_app['Settings'] >,
			'profile': ReturnType< $shm_hitalama_app['Profile_page'] >,
		}) 
		Components( ): ReturnType< $shm_hitalama_app['Applications'] >
		Guide( ): $shm_hitalama_guide_panel
		Auth_gate( ): $shm_hitalama_entergate_app
		Recovery_page( id: any): $shm_hitalama_resilience_page
		Enter( ): $shm_hitalama_profile_enter
		Register( ): $shm_hitalama_profile_register
		no_auth_pages( ): ({ 
			'domain_page': ReturnType< $shm_hitalama_app['Domain_page'] >,
		}) 
		Map( ): $shm_hitalama_map_book
		Ext( ): $shm_hitalama_extension_app
		Chat( ): $shm_hitalama_agent_map_chat
		Map_codex( ): $shm_hitalama_codex_map
		General_chat( ): $shm_hitalama_agent_general
		General_codex( ): $shm_hitalama_codex_general
		Project_chat( ): $shm_hitalama_project_codex
		Process_monitor( ): $shm_hitalama_process_monitor_maps
		History( ): $shm_hitalama_map_history_view
	}
	
}

//# sourceMappingURL=app.web.view.tree.d.ts.map